module.exports = __webpack_public_path__ + "img/closeCross.ac277310.svg";